export const SET_WIZARD_COUNTRY = 'SET_WIZARD_COUNTRY';
export const SET_WIZARD_FWK = 'SET_WIZARD_FWK';
export const SET_WIZARD_FORK = 'SET_WIZARD_FORK';
export const SET_WIZARD_LOCATION = 'SET_WIZARD_LOCATION';
export const SET_WIZARD_EXECUTION_TYPE = 'SET_WIZARD_EXECUTION_TYPE';
export const SET_WIZARD_MEDIUM_TYPE = 'SET_WIZARD_MEDIUM_TYPE';
export const SET_WIZARD_PRODUCT_SYSTEM = 'SET_WIZARD_PRODUCT_SYSTEM';
export const SET_WIZARD_BY_PRODUCT_SOLUTION = 'SET_WIZARD_BY_PRODUCT_SOLUTION';
export const ERROR_FETCHING_WIZARD_BY_PRODUCT_SOLUTION = 'ERROR_FETCHING_WIZARD_BY_PRODUCT_SOLUTION';
export const RESET_ERROR_FETCHING_WIZARD_BY_PRODUCT_SOLUTION = 'RESET_ERROR_FETCHING_WIZARD_BY_PRODUCT_SOLUTION';


export const UNSET_WIZARD_COUNTRY = 'UNSET_WIZARD_COUNTRY';
export const UNSET_WIZARD_FWK = 'UNSET_WIZARD_FWK';
export const UNSET_WIZARD_FORK = 'UNSET_WIZARD_FORK';
export const UNSET_WIZARD_LOCATION = 'UNSET_WIZARD_LOCATION';
export const UNSET_WIZARD_EXECUTION_TYPE = 'UNSET_WIZARD_EXECUTION_TYPE';
export const UNSET_WIZARD_MEDIUM_TYPE = 'UNSET_WIZARD_MEDIUM_TYPE';
export const ADD_WIZARD_MEDIUM_TYPE = 'ADD_WIZARD_MEDIUM_TYPE';
export const REMOVE_WIZARD_MEDIUM_TYPE = 'REMOVE_WIZARD_MEDIUM_TYPE';

export const ADD_WIZARD_PRODUCT_SYSTEM_ITEM = 'ADD_WIZARD_PRODUCT_SYSTEM_ITEM';
export const REMOVE_WIZARD_PRODUCT_SYSTEM_ITEM = 'REMOVE_WIZARD_PRODUCT_SYSTEM_ITEM';

export const FETCH_PROJECTS_FAILED = 'FETCH_PROJECTS_FAILED';
export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const FETCH_PROJECTS_START = 'FETCH_PROJECTS_START';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';



export const SAVE_PROJECT_FAILED = 'SAVE_PROJECT_FAILED';
export const SAVE_PROJECT_SUCCESS = 'SAVE_PROJECT_SUCCESS';
export const SAVE_PROJECT_START = 'SAVE_PROJECT_START';

export const FETCH_PROJECT_FAILED = 'FETCH_PROJECT_FAILED';
export const FETCH_PROJECT_SUCCESS = 'FETCH_PROJECT_SUCCESS';
export const FETCH_PROJECT_START = 'FETCH_PROJECT_START';

export const UPDATE_PROJECT_FAILED = 'UPDATE_PROJECT_FAILED';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const UPDATE_PROJECT_START = 'UPDATE_PROJECT_START';

export const DELETE_PROJECT_FAILED = 'DELETE_PROJECT_FAILED';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_START = 'DELETE_PROJECT_START';



export const CREATE_PROJECTUNIT_FAILED = 'CREATE_PROJECTUNIT_FAILED';
export const CREATE_PROJECTUNIT_SUCCESS = 'CREATE_PROJECTUNIT_SUCCESS';
export const CREATE_PROJECTUNIT_START = 'CREATE_PROJECTUNIT_START';

export const UPDATE_PROJECTUNIT_FAILED = 'UPDATE_PROJECTUNIT_FAILED';
export const UPDATE_PROJECTUNIT_SUCCESS = 'UPDATE_PROJECTUNIT_SUCCESS';
export const UPDATE_PROJECTUNIT_START = 'UPDATE_PROJECTUNIT_START';

export const DELETE_PROJECTUNIT_FAILED = 'DELETE_PROJECTUNIT_FAILED';
export const DELETE_PROJECTUNIT_SUCCESS = 'DELETE_PROJECTUNIT_SUCCESS';
export const DELETE_PROJECTUNIT_START = 'DELETE_PROJECTUNIT_START';



export const FETCH_PRODUCTSYSTEMS_FAILED = 'FETCH_PRODUCTSYSTEMS_FAILED';
export const FETCH_PRODUCTSYSTEMS_SUCCESS = 'FETCH_PRODUCTSYSTEMS_SUCCESS';
export const FETCH_PRODUCTSYSTEMS_START = 'FETCH_PRODUCTSYSTEMS_START';

export const FETCH_PRODUCTSOLUTION_FAILED = 'FETCH_PRODUCTSOLUTION_FAILED';
export const FETCH_PRODUCTSOLUTION_SUCCESS = 'FETCH_PRODUCTSOLUTION_SUCCESS';
export const FETCH_PRODUCTSOLUTION_START = 'FETCH_PRODUCTSOLUTION_START';



export const CREATE_PRODUCTSOLUTION_START = 'CREATE_PRODUCTSOLUTION_START';
export const CREATE_PRODUCTSOLUTION_SUCCESS = 'CREATE_PRODUCTSOLUTION_SUCCESS';
export const CREATE_PRODUCTSOLUTION_FAILED = 'CREATE_PRODUCTSOLUTION_FAILED';

export const UPDATE_PRODUCTSOLUTION_FAILED = 'UPDATE_PRODUCTSOLUTION_FAILED';
export const UPDATE_PRODUCTSOLUTION_SUCCESS = 'UPDATE_PRODUCTSOLUTION_SUCCESS';
export const UPDATE_PRODUCTSOLUTION_START = 'UPDATE_PRODUCTSOLUTION_START';

export const FETCH_PROJECT_OFFER_POSITIONS_START = 'FETCH_PROJECT_OFFER_POSITIONS_START';
export const FETCH_PROJECT_OFFER_POSITIONS_SUCCESS = 'FETCH_PROJECT_OFFER_POSITIONS_SUCCESS';
export const FETCH_PROJECT_OFFER_POSITIONS_FAILED = 'FETCH_PROJECT_OFFER_POSITIONS_FAILED';

export const UPDATE_PROJECTOFFERPOSITIONS_START = 'UPDATE_PROJECTOFFERPOSITIONS_START';
export const UPDATE_PROJECTOFFERPOSITIONS_SUCCESS = 'UPDATE_PROJECTOFFERPOSITIONS_SUCCESS';
export const UPDATE_PROJECTOFFERPOSITIONS_FAILED = 'UPDATE_PROJECTOFFERPOSITIONS_FAILED';

export const SET_WIZARD_SCOPE_PROJECT = 'SET_WIZARD_SCOPE_PROJECT';
export const SET_WIZARD_SCOPE_PROJECTUNIT = 'SET_WIZARD_SCOPE_PROJECTUNIT';


export const DELETE_PROJECTSOLUTION_START = 'DELETE_PROJECTSOLUTION_START';
export const DELETE_PROJECTSOLUTION_SUCCESS = 'DELETE_PROJECTSOLUTION_SUCCESS';
export const DELETE_PROJECTSOLUTION_FAILED = 'DELETE_PROJECTSOLUTION_FAILED';

export const CLONE_PROJECTSOLUTION_START = 'CLONE_PROJECTSOLUTION_START';
export const CLONE_PROJECTSOLUTION_SUCCESS = 'CLONE_PROJECTSOLUTION_SUCCESS';
export const CLONE_PROJECTSOLUTION_FAILED = 'CLONE_PROJECTSOLUTION_FAILED';


export const CLONE_PROJECTUNIT_START = 'CLONE_PROJECTUNIT_START';
export const CLONE_PROJECTUNIT_SUCCESS = 'CLONE_PROJECTUNIT_SUCCESS';
export const CLONE_PROJECTUNIT_FAILED = 'CLONE_PROJECTUNIT_FAILED';

export const CLONE_PROJECT_START = 'CLONE_PROJECT_START';
export const CLONE_PROJECT_SUCCESS = 'CLONE_PROJECT_SUCCESS';
export const CLONE_PROJECT_FAILED = 'CLONE_PROJECT_FAILED';

export const DEACTIVATE_PROJECT_START = 'DEACTIVATE_PROJECT_START';
export const DEACTIVATE_PROJECT_SUCCESS = 'DEACTIVATE_PROJECT_SUCCESS';
export const DEACTIVATE_PROJECT_FAILED = 'DEACTIVATE_PROJECT_FAILED';

export const REACTIVATE_PROJECT_START = 'REACTIVATE_PROJECT_START';
export const REACTIVATE_PROJECT_SUCCESS = 'REACTIVATE_PROJECT_SUCCESS';
export const REACTIVATE_PROJECT_FAILED = 'REACTIVATE_PROJECT_FAILED';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAILED = 'AUTH_FAILED';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const SAVE_PROFILE_START = 'SAVE_PROFILE_START';
export const SAVE_PROFILE_SUCCESS = 'SAVE_PROFILE_SUCCESS';
export const SAVE_PROFILE_FAILED = 'SAVE_PROFILE_FAILED';

export const FETCH_USERS_FAILED = 'FETCH_USERS_FAILED';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_USERS_START = 'FETCH_USERS_START';

export const SAVE_SETTINGS_START = 'SAVE_SETTINGS_START';
export const SAVE_SETTINGS_SUCCESS = 'SAVE_SETTINGS_SUCCESS';
export const SAVE_SETTINGS_FAILED = 'SAVE_SETTINGS_FAILED';

export const CREATE_ACCOUNT_FAILED = 'CREATE_ACCOUNT_FAILED';
export const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
export const CREATE_ACCOUNT_START = 'CREATE_ACCOUNT_START';

export const REGISTER_VERIFICATION_FAILED = 'REGISTER_VERIFICATION_FAILED';
export const REGISTER_VERIFICATION_SUCCESS = 'REGISTER_VERIFICATION_SUCCESS';
export const REGISTER_VERIFICATION_START = 'REGISTER_VERIFICATION_START';

export const RECREATE_PASSWORD_FAILED = 'RECREATE_PASSWORD_FAILED';
export const RECREATE_PASSWORD_SUCCESS = 'RECREATE_PASSWORD_SUCCESS';
export const RECREATE_PASSWORD_START = 'RECREATE_PASSWORD_START';

export const NEW_PASSWORD_REQUEST_FAILED = 'NEW_PASSWORD_REQUEST_FAILED';
export const NEW_PASSWORD_REQUEST_SUCCESS = 'NEW_PASSWORD_REQUEST_SUCCESS';
export const NEW_PASSWORD_REQUEST_START = 'NEW_PASSWORD_REQUEST_START';

export const SAVE_PASSWORD_START = 'SAVE_PASSWORD_START';
export const SAVE_PASSWORD_SUCCESS = 'SAVE_PASSWORD_SUCCESS';
export const SAVE_PASSWORD_FAILED = 'SAVE_PASSWORD_FAILED';

export const FETCH_PRODUCT_SYSTEM_FAILED = 'FETCH_PRODUCT_SYSTEM_FAILED';
export const FETCH_PRODUCT_SYSTEM_SUCCESS = 'FETCH_PRODUCT_SYSTEM_SUCCESS';
export const FETCH_PRODUCT_SYSTEM_START = 'FETCH_PRODUCT_SYSTEM_START';

export const ADD_ITEM_TO_SOLUTION = 'ADD_ITEM_TO_SOLUTION';
export const REMOVE_ITEM_FROM_SOLUTION = 'REMOVE_ITEM_FROM_SOLUTION';

export const DELETE_ACCOUNT_START = 'DELETE_ACCOUNT_START';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_FAILED = 'DELETE_ACCOUNT_FAILED';


export const SET_WIZARD_UNFINISHED = 'SET_WIZARD_UNFINISHED';
export const SET_WIZARD_FINISHED = 'SET_WIZARD_FINISHED';

export const FETCH_DOCUMENTATIONFILES_FAILED = 'FETCH_DOCUMENTATIONFILES_FAILED';
export const FETCH_DOCUMENTATIONFILES_SUCCESS = 'FETCH_DOCUMENTATIONFILES_SUCCESS';
export const FETCH_DOCUMENTATIONFILES_START = 'FETCH_DOCUMENTATIONFILES_START';

export const FETCH_DOCUMENTATIONFILEUSERINFOS_FAILED = 'FETCH_DOCUMENTATIONFILEUSERINFOS_FAILED';
export const FETCH_DOCUMENTATIONFILEUSERINFOS_SUCCESS = 'FETCH_DOCUMENTATIONFILEUSERINFOS_SUCCESS';
export const FETCH_DOCUMENTATIONFILEUSERINFOS_START = 'FETCH_DOCUMENTATIONFILEUSERINFOS_START';

export const DELETE_DOCUMENTATIONFILEUSERINFOS_FAILED = 'DELETE_DOCUMENTATIONFILEUSERINFOS_FAILED';
export const DELETE_DOCUMENTATIONFILEUSERINFOS_SUCCESS = 'DELETE_DOCUMENTATIONFILEUSERINFOS_SUCCESS';
export const DELETE_DOCUMENTATIONFILEUSERINFOS_START = 'DELETE_DOCUMENTATIONFILEUSERINFOS_START';

export const DELETE_DOCUMENTATIONFILEUSERINFOS_IN_PRODUCTSYSTEM_SUCCESS = 'DELETE_DOCUMENTATIONFILEUSERINFOS_IN_PRODUCTSYSTEM_SUCCESS';

export const DELETE_ALL_DOCUMENTATIONFILEUSERINFOS_FAILED = 'DELETE_ALL_DOCUMENTATIONFILEUSERINFOS_FAILED';
export const DELETE_ALL_DOCUMENTATIONFILEUSERINFOS_SUCCESS = 'DELETE_ALL_DOCUMENTATIONFILEUSERINFOS_SUCCESS';
export const DELETE_ALL_DOCUMENTATIONFILEUSERINFOS_START = 'DELETE_ALL_DOCUMENTATIONFILEUSERINFOS_START';

export const FETCH_ACCESS_TOKENS_START = 'FETCH_ACCESS_TOKENS_START';
export const FETCH_ACCESS_TOKENS_SUCCESS = 'FETCH_ACCESS_TOKENS_SUCCESS';
export const FETCH_ACCESS_TOKENS_FAILED = 'FETCH_ACCESS_TOKENS_FAILED';

export const SAVE_ACCESS_TOKEN_START = 'SAVE_ACCESS_TOKEN_START';
export const SAVE_ACCESS_TOKEN_SUCCESS = 'SAVE_ACCESS_TOKEN_SUCCESS';
export const SAVE_ACCESS_TOKEN_FAILED = 'SAVE_ACCESS_TOKEN_FAILED';

export const DELETE_ACCESS_TOKEN_START = 'DELETE_ACCESS_TOKEN_START';
export const DELETE_ACCESS_TOKEN_SUCCESS = 'DELETE_ACCESS_TOKEN_SUCCESS';
export const DELETE_ACCESS_TOKEN_FAILED = 'DELETE_ACCESS_TOKEN_FAILED';

export const CALCULATE_PRODUCTSOLUTION_CONSUMPTION_START = 'CALCULATE_PRODUCTSOLUTION_CONSUMPTION_START';
export const CALCULATE_PRODUCTSOLUTION_CONSUMPTION_SUCCESS = 'CALCULATE_PRODUCTSOLUTION_CONSUMPTION_SUCCESS';
export const CALCULATE_PRODUCTSOLUTION_CONSUMPTION_FAILED = 'CALCULATE_PRODUCTSOLUTION_CONSUMPTION_FAILED';

export const CALCULATE_PROJECT_CONSUMPTION_START = 'CALCULATE_PROJECT_CONSUMPTION_START';
export const CALCULATE_PROJECT_CONSUMPTION_SUCCESS = 'CALCULATE_PROJECT_CONSUMPTION_SUCCESS';
export const CALCULATE_PROJECT_CONSUMPTION_FAILED = 'CALCULATE_PROJECT_CONSUMPTION_FAILED';

export const UPDATE_PROJECTOFFERPOSITIONSDETAILS_START = 'UPDATE_PROJECTOFFERPOSITIONSDETAILS_START';
export const UPDATE_PROJECTOFFERPOSITIONSDETAILS_SUCCESS = 'UPDATE_PROJECTOFFERPOSITIONSDETAILS_SUCCESS';
export const UPDATE_PROJECTOFFERPOSITIONSDETAILS_FAILED = 'UPDATE_PROJECTOFFERPOSITIONSDETAILS_FAILED';



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js